import isEmpty from 'lodash/isEmpty';
import {
  ReactNode, useEffect, useState,
} from 'react';
import {
  FormGroup, Input, Label, InputProps,
  FormFeedback,
} from 'reactstrap';

export interface CheckboxInputProps extends InputProps {
  label?: string | ReactNode
  name?: string
  id?: string
  type: 'checkbox'
  checked?: boolean
  formGrpClassName?: string
  labelClassName?: string
  fieldError?: string
  isReadOnly?: boolean
  isDisabled?: boolean
  onInputChangeHandler?: (value: boolean) => void
}

// eslint-disable-next-line react/display-name
const Checkbox = (({
  label = '', name = '', id, type, checked = false, onInputChangeHandler = () => {},
  isReadOnly = false, isDisabled = false, formGrpClassName = '', labelClassName = '', fieldError = '', ...props
}: CheckboxInputProps) => {
  const [ error, setError ] = useState(fieldError);

  useEffect(() => {
    if (!isEmpty(fieldError) && fieldError !== error) {
      setError(fieldError);
      return;
    }
    setError('');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ fieldError ]);

  return (
    <FormGroup
      check
      className={`form-group ${formGrpClassName}`}
    >
      <Input
        {...props}
        id={id}
        name={name}
        type={type}
        // innerRef={ref as React.Ref<HTMLInputElement | HTMLTextAreaElement>}
        className="custom-checkbox"
        checked={checked}
        onChange={(e: any) => onInputChangeHandler(e)}
        invalid={!isEmpty(error)}
        disabled={isDisabled}
        readOnly={isReadOnly}
      />
      <Label check className={labelClassName}>
        {label}
      </Label>
      <FormFeedback>{error}</FormFeedback>
    </FormGroup>
  );
});

export default Checkbox;
